import React from 'react';
import pauseWritingLaptopSrc from '../../assets/images/slide/pause-writing-laptop.png';
import styles from './PauseSlideContentV9.css';

function PauseSlideContentV9() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseWritingLaptopSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.content}>
                <div className={styles.headingSection}>
                    <h2 className={styles.heading}>You&apos;ve got more to work with than you think</h2>
                    <p className={styles.description}>You already have a feel for this. We fix the grammar, smooth the sentences and put the chapters in order. It still sounds like you. That&apos;s the entire point.</p>
                </div>
                <div className={styles.highlightBox}>
                    <p className={styles.highlightTitle}>We will handle:</p>
                    <p className={styles.highlightText}>grammar, sentence flow, tone, chapter order, layout and photos</p>
                </div>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV9
};
